module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_3.529dc108.jpg";